<ng-container *transloco="let t">
  <ld-base-modal [title]="t('commonMakePayment')" (closeModal)="onClose()">
    <div modal-content>
      @if (isLoading()) {
        <div class="absolute inset-0 flex items-center justify-center bg-white">
          <div class="flex flex-col items-center gap-4">
            <mat-spinner diameter="48"></mat-spinner>
            <p class="font-dm text-sm text-ld-neutral-500">{{ t('modalsPaymentPortalLoading') }}</p>
          </div>
        </div>
      }

      @if (hasError()) {
        <div class="absolute inset-0 flex items-center justify-center bg-white">
          <div class="flex flex-col items-center gap-4 text-center px-6">
            <div class="size-16 rounded-full bg-red-100 flex items-center justify-center">
              <img [src]="errorIcon" alt="Error" class="w-8 h-8" />
            </div>
            <h3 class="font-dm text-lg font-semibold text-ld-neutral">{{ t('modalsPaymentPortalErrorTitle') }}</h3>
            <p class="font-dm text-sm text-ld-neutral-500">{{ t('modalsPaymentPortalErrorMessage') }}</p>
            <button
              type="button"
              class="px-6 py-2.5 text-sm font-dm font-semibold text-white bg-ld-primary rounded-lg hover:bg-ld-primary-600 transition-colors cursor-pointer"
              (click)="onClose()"
            >
              {{ t('commonAriaClose') }}
            </button>
          </div>
        </div>
      }

      <iframe
        id="payment-portal-iframe"
        [src]="safeUrl()"
        class="w-full h-full border-0"
        [class.invisible]="isLoading() || hasError()"
        (load)="onIframeLoad()"
        (error)="onIframeError()"
        title="Payment Portal"
      ></iframe>
    </div>
    <div modal-footer>
      <button id="payment-portal-cancel-btn" type="button" class="btn-outline-ld-purple" (click)="onClose()">
        {{ t('commonButtonsCancel') }}
      </button>
      <button id="payment-portal-done-btn" type="button" class="btn-primary-ld-purple" (click)="onDone()">
        {{ t('commonButtonsDone') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
